import {dataset, datasetsEnums} from "@leap4/frontend";
import moment from "moment";
import {IBaseTagMetric} from "@leap4/entities-discrepancy-common";
import {EntitiesProperties} from "../../../../utils/enums";
import {DateTime} from "luxon";

export const graphDataProgressions = [
    {name: 'Delta', value: datasetsEnums.DELTA},
    {name: 'Accumulated', value: datasetsEnums.ACCUMULATE}
]

export enum TimeDisplayInterval {
    Daily = 'daily',
    Hourly = 'hourly'
}

export const TimeDisplay = [
    {name: 'Daily', value: TimeDisplayInterval.Daily},
    {name: 'Hourly', value: TimeDisplayInterval.Hourly}
]

export function getDefaultTimeDisplay(startDate: string, endDate: string): number {
    return startDate === endDate ? 1 : 0
}

export function indexToTimeInterval(index: number): TimeDisplayInterval {
    return TimeDisplay[index].value
}

export function getValuesByMetricForIntervalType(transactions: IBaseTagMetric[], selectedMetric: string, intervalType: TimeDisplayInterval, type): any[] {
    const {VCR, FILL_RATE} = EntitiesProperties.NUMERIC.ALL
    if (type === "Absolute") {
        if (selectedMetric === VCR) return transactions.map(tr => tr["vcr"])
        if (selectedMetric === FILL_RATE) return transactions.map(tr => tr["fillRate"])
        if (selectedMetric === EntitiesProperties.NUMERIC.ALL.CPM) return transactions.map(tr => tr.impressions === 0 ? 0 : tr["cost"] / tr.impressions * 1000);
        if (selectedMetric === EntitiesProperties.NUMERIC.ALL.RPM) return transactions.map(tr => tr.impressions === 0 ? 0 : tr.revenue / tr.impressions * 1000);
    }
    let valuesByMetric = transactions.map((x: IBaseTagMetric) => {
        if (selectedMetric === EntitiesProperties.NUMERIC.ALL.PROFIT) return x.revenue - x["cost"];
        if (selectedMetric === EntitiesProperties.NUMERIC.ALL.NET_PROFIT) return x["netRevenue"] - x["netCost"];
        return x[selectedMetric];
    })

    if (intervalType === TimeDisplayInterval.Hourly) {
        let highestUntilNow = 0
        valuesByMetric = valuesByMetric.map((currentValue, index, currArray) => {
            const valueBefore = index === 0 ? 0 : currArray[index - 1];
            if (valueBefore > highestUntilNow) {
                highestUntilNow = valueBefore
            }
            return Math.max(currentValue - highestUntilNow, 0)
        })
    }
    return valuesByMetric
}

export function getLabelsForGraph(s: string, e: string, intervalType: TimeDisplayInterval): any[] {

    if (intervalType === TimeDisplayInterval.Hourly) {
        const startDate = DateTime.fromJSDate(new Date(s)).toUTC().startOf("day")
        const endDate = DateTime.fromJSDate(new Date(e)).plus({day: 1}).toUTC().startOf("day")
        let currentDate = startDate;
        const ans = []
        while (currentDate <= endDate) {
            ans.push(currentDate.toJSDate().toString())
            currentDate = currentDate.plus({minute: 30})
        }
        return ans;
    } else {
        const startDate = DateTime.fromJSDate(new Date(s)).endOf("day").toUTC()
        let endDate = DateTime.fromJSDate(new Date(e)).endOf("day").toUTC();
        if(endDate.toISODate() === DateTime.now().toUTC().toISODate()){
            endDate = endDate.minus({day: 1})
        }
        let currentDate = startDate;
        const ans = []
        while (currentDate <= endDate) {
            ans.push(currentDate)
            currentDate = currentDate.plus({day: 1})
        }
        return ans;
    }

}

export function roundDate(date: Date): Date {
    const minutes = 30;
    const ms = 1000 * 60 * minutes;

    // 👇️ replace Math.round with Math.ceil to always round UP
    return new Date(Math.round(date.getTime() / ms) * ms);
}

export function getXAxisFormatFunc(startDate: string, endDate: string, intervalType: TimeDisplayInterval): any {
    if (intervalType === TimeDisplayInterval.Hourly) {
        if (startDate === endDate) {
            return (timestamp) => moment(roundDate(new Date(timestamp))).utc().format("HH:mm")
        } else {
            return (timestamp) => moment(roundDate(new Date(timestamp))).utc().format("DD/MM HH:mm")
        }
    } else {
        return (timestamp) => moment(roundDate(new Date(timestamp))).utc().format("DD/MM")
    }
}

export function getDatasetsForGraph(allValues, metric, intervalType, type, graphIntervalIndx): Array<dataset> {
    let values = []
    values = getValuesByMetricForIntervalType(allValues.selectedDates.data.map(x => x.totals), metric, intervalType, type)
    let selectedDatesDataset: dataset = {type, labelName: 'Selected Dates', values, backgroundColor: null}
    values = getValuesByMetricForIntervalType(allValues.dayAgo.data.map(x => x.totals), metric, intervalType, type)
    let dayAgoDataset: dataset = {type, labelName: 'Day Ago (-1)', values}
    if (graphIntervalIndx === 0 || allValues?.specificComparisonDate?.data?.length) //It means that is daily, not hourly, not need in day-ago
        dayAgoDataset.hidden = true;

    values = getValuesByMetricForIntervalType(allValues.weekAgo.data.map(x => x.totals), metric, intervalType, type)
    let weekAgoDataset: dataset = {
        type,
        labelName: 'Week Ago (-7)',
        values,
        borderColor: 'orange',
        backgroundColor: '#ffa50059',
        hidden: true
    }

    values = getValuesByMetricForIntervalType(allValues.monthAgo.data.map(x => x.totals), metric, intervalType, type)
    let monthAgoDataset: dataset = {type, labelName: 'Month Ago (-28)', values, hidden: true}

    if(allValues?.specificComparisonDate?.data?.length) {
        values = getValuesByMetricForIntervalType(allValues?.specificComparisonDate?.data?.map(x=>x.totals), metric, intervalType, type)
     const specificComparisonDate: dataset = {type, labelName: 'Specific Date', values,        borderColor: 'rgba(17,30,255,0.67)',
         backgroundColor: '#3838ff', hidden: false}
    return [selectedDatesDataset, dayAgoDataset, weekAgoDataset, monthAgoDataset, specificComparisonDate ]
    }

    return [selectedDatesDataset, dayAgoDataset, weekAgoDataset, monthAgoDataset ]
}


